/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NewThreadAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function NewThreadAction({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Empty/NewThreadAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Content'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}